import XLSX from 'xlsx';
import FileSaver from 'file-saver';

export default {
	data() {
		return {
			// 性别
			sex: ['男', '女'],
			// 是否禁用
			enabled: [{
					type: 1,
					text: '启用'
				},
				{
					type: 0,
					text: '禁用'
				}
			],
			//用来临时保存取消年度和修改年度的临时值
			temporaryYear: '',
			// 当前页面
			currentPage: 1,
			//每页的数据
			pageLen: 15,
			//课程的搜索名字
			classSearchName: '',
			//上传的文件
			fileListTwo: [],
			//上传的接口地址
			addressTwo: this.baseUrl + 'file/import_users?token=' + this.$store.state.authority_management,
			//下载模板地址
			download: 'https://zzrc.bayou-tech.cn/excel_template/批量学员注册模板.xls',
			// 选课时候设置年度
			isFirst: '',
			//搜索学生的条件
			searchStudent: {
				code: '',
				name: '',
				company: '',
				phone: '',
				idCard: '',
				sex: '',
				enabled: '',
				created_at_egt: '',
				created_at_elt: '',
				gender: '',
				enabled: '',
				birthdate: '',
				email: '',
				created_people: '',
				balance_egt: '',
				balance_elt: '',
				province: '',
				city: '',
				note: ''
			},
			//创建学员的条件
			createdStudent: {
				name: '',
				idCard: '',
				phone: '',
				password: '',
				email: '',
				head_image: '',
				company: '',
				province: '',
				city: '',
				banlance: '',
				note: '',
				gender: '',
				token: this.$store.state.authority_management
			},
			//辨别是用条件搜索还是全部搜索学生=>默认全部
			searchType: true,
			// 当前选择课程的学员id
			studentId: '',
			//学生总数量
			studentTotal: 0,
			//学生搜素当前页
			studentSearchCurrentPage: 0,
			//学生当前页
			studentCurrentPage: 0,
			//课程总数量
			classTotal: 0,
			//课程当前页
			classCurrentPage: 0,
			//修改
			cer_year: '',
			//已经勾选了多个课程
			paruseSelectClass: [],
			//已经勾选了多个学生
			paruseStudent: [],
			//已经勾选了多个已选课程
			paruseClass: [],
			//判断表单里面是否需要出现密码输入框
			isPassword: true,
			//弹出框的标题
			title: "添加学员",
			//控制表单弹出框的显隐
			dialogFormVisible: false,
			//控制已购买课程的表格弹出框
			dialogTabelVisible: false,
			//控制未购买课程的表格弹出框
			dialogSelectVisible: false,
			//已选课程的列表弹出框
			dialogSelectedVisible: false,
			//批量注册弹出框
			moreChooseDialog: false,
			isInput: {
				name: false,
				idCard: false,
				phone: false,
				company: false,
				email: false,
			},
			// 表单的对象绑定的值
			form: {
				name: "",
				idCard: "",
				phone: '',
				password: '',
				confirmPassword: '',
				company: '',
				email: '',
			},
			//表单的样式宽度
			formLabelWidth: "120px",
			//学生数据
			studnetData: [],
			// 课程数据
			classData: [],
			//弹出框的搜索字符串
			search: "",
			//所有产品
			selectData: [],
			//已经选到的课程
			selectedData: [],
			//直接开课的时候填写的年度
			directYear: '',
			//直接开课的弹框
			dialogdirectVisible: false,
			//修改学员信息弹出框
			dialogUpdatetVisible: false,
			// 新增学员
			addDialoglVisible: false,
			//绑定在输入框的学员信息
			stuInfo: {},
			// loading状态
			fullscreenLoading: false,
			//修改密码
			currentPasswordDialog: false,
			// 修改密码字段
			currentPassword: '',
			errorMsg: [],

			// 导出excel
			excelDialog: false,
			exceldata: {
				offset: '',
				length: ''
			},
			// 显示导出加载中
			exportLoading: false,
		}
	},
	methods: {

		//批量注册
		upload(q) {
			this.errorMsg = []
			this.$upload(this.addressTwo, q).then(res => {
				if (!res.data.result.status) {
					this.errorMsg = res.data.result.msg
				} else {
					this.$message({
						type: 'success',
						message: '批量注册成功'
					})
				}
			}).catch(err => {
				console.log(err)
			})
		},
		//确认修改密码
		confirmCurrent() {
			if (this.currentPassword.length < 6) {
				this.$message.error('密码最少为6位!');
				return;
			}
			this.$confirm('是否把该学员的密码改为：' + this.currentPassword, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$post('users/editPassword', {
					token: this.$store.state.authority_management,
					id: this.stuInfo.id,
					password: this.currentPassword
				}).then(res => {
					console.log(res)
					if (res.data.status == 'fail') {
						this.$message({
							type: 'error',
							message: res.data.errorMsg
						})
					} else {
						this.currentPasswordDialog = false;
						this.$message({
							type: 'success',
							message: '修改成功'
						})
					}
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消修改'
				});
			});
		},
		//新增学员
		adduser() {
			//电话号码的校验正则
			let phoneReg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
			//身份证的校验正则
			let idcardReg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9X]$/;
			if (this.createdStudent.name == '') {
				this.$message({
					showClose: true,
					message: '姓名不能为空',
					type: 'warning'
				});
				return false;
			} else if (this.createdStudent.name.length > 6) {
				this.$message({
					showClose: true,
					message: '姓名不能超过六位',
					type: 'warning'
				});
				return false;
			} else if (this.createdStudent.password == '') {
				this.$message({
					showClose: true,
					message: '密码不能为空',
					type: 'warning'
				});
				return false;
			} else if (this.createdStudent.gender == '') {
				this.$message({
					showClose: true,
					message: '性别不能为空',
					type: 'warning'
				});
				return false;
			}  else if (this.createdStudent.idCard == '' || !idcardReg.test(this.createdStudent.idCard)) {
				this.$message({
					showClose: true,
					message: '身份证格式错误',
					type: 'warning'
				});
				return false;
			}  else {
				this.$post('users/createUser', this.createdStudent)
					.then(res => {
						console.log(res)
						if (res.data.status == 'success') {
							this.addDialoglVisible = false;
							this.createdStudent = {
								name: '',
								idCard: '',
								phone: '',
								password: '',
								email: '',
								head_image: '',
								company: '',
								province: '',
								city: '',
								banlance: '',
								note: '',
								gender: '',
								token: this.$store.state.authority_management
							}
							this.$message({
								showClose: true,
								message: '新增成功',
								type: 'success'
							});
							this.getAllStudent();
						} else {
							this.$message({
								showClose: true,
								message: res.data.errorMsg,
								type: 'error'
							});
						}
					})
			}
		},
		//修改密码
		currentStudentPassword() {
			this.currentPassword = ''
			if (this.paruseStudent.length == 0) {
				this.$message({
					type: 'error',
					message: '请选择用户'
				})
				return false
			} else if (this.paruseStudent.length > 1) {
				this.$message({
					type: 'error',
					message: '请选择单个用户'
				})
				return false
			} else {
				this.currentPasswordDialog = true;
			}
		},
		//弹出学员信息框并显示学员信息
		updateStuInfo(info) {

			if (this.paruseStudent.length == 0) {
				this.$message({
					type: 'error',
					message: '请选择用户'
				})
				return false
			} else if (this.paruseStudent.length > 1) {
				this.$message({
					type: 'error',
					message: '请选择单个用户'
				})
				return false
			} else {
				this.dialogUpdatetVisible = true;
			}
			// console.log(info);
			// this.stuInfo = info;

		},
		confirmUpdateStuInfo() {
			// //电话号码的校验正则
			// let phoneReg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
			// //身份证的校验正则
			// let idcardReg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9X]$/;
			// if (this.stuInfo.name == '') {
			// 	this.$message({
			// 		showClose: true,
			// 		message: '姓名不能为空',
			// 		type: 'warning'
			// 	});
			// 	return false;
			// } else if (this.stuInfo.idcard == '' || !idcardReg.test(this.stuInfo.idcard)) {
			// 	this.$message({
			// 		showClose: true,
			// 		message: '身份证格式错误',
			// 		type: 'warning'
			// 	});
			// 	return false;
			// } else if (this.stuInfo.phone == '' || !phoneReg.test(this.stuInfo.phone)) {
			// 	this.$message({
			// 		showClose: true,
			// 		message: '手机号码格式错误',
			// 		type: 'warning'
			// 	});
			// 	return false;
			// } else if (this.stuInfo.gender == '') {
			// 	this.$message({
			// 		showClose: true,
			// 		message: '性别不能为空',
			// 		type: 'warning'
			// 	});
			// 	return false;
			// } else {
			// this.$post('users/search', {
			//     idcard: this.stuInfo.idcard,
			//     offset: 0,
			//     length: 999,
			//     token: this.$store.state.authority_management
			// }).then(res => {
			//     console.log(res)
			//     if (res.data.result.total > 0) {
			//         this.$message({
			//             showClose: true,
			//             message: '该身份证已存在',
			//             type: 'error'
			//         });
			//     } else {
			let data = {
				id: this.stuInfo.id,
				idcard: this.stuInfo.idcard,
				phone: this.stuInfo.phone,
				company: this.stuInfo.company,
				email: this.stuInfo.email,
				code: this.stuInfo.code,
				name: this.stuInfo.name,
				gender: this.stuInfo.gender,
				birthdate: this.stuInfo.birthdate,
				province: this.stuInfo.province,
				city: this.stuInfo.city,
				note: this.stuInfo.note,
				enabled: this.stuInfo.enabled,
				token: this.$store.state.authority_management
			}
			this.$post('users/shop_edit', data).then(res => {
				// console.log(res);
				if (res.data.status == 'success') {
					this.dialogUpdatetVisible = false;
					this.$message({
						showClose: true,
						message: '修改成功',
						type: 'success'
					});
					this.getAllStudent();
				} else {
					this.$message({
						showClose: true,
						message: '修改失败',
						type: 'error'
					});
				}
			})
			//     }
			// })
			// }
		},

		//该页每页要的数组
		handleSizeChange(val) {
			this.pageLen = val;
			this.getAllStudent();
		},
		//确定直接选课的年度
		confirmDirectYear() {
			let arr = [];
			for (let val of this.paruseSelectClass) {
				arr.push(val.id);
			}
			if (this.paruseStudent.length == 0) {
				this.$post('orders/batch_create', {
					token: this.$store.state.authority_management,
					user_id_arr: JSON.stringify([this.studentId]),
					product_ids: JSON.stringify(arr),
					is_first: this.directYear
				}).then(res => {
					if (res.data.status == 'success') {
						this.$message({
							showClose: true,
							message: '开课成功！',
							type: 'success'
						});
						this.dialogdirectVisible = false;
						this.paruseSelectClass = [];
						this.dialogSelectVisible = false;
					} else {
						this.$message({
							showClose: true,
							message: '开课失败' + res.data.errorMsg,
							type: 'danger'
						});
					}
				})
			} else {
				this.$post('orders/batch_create', {
					token: this.$store.state.authority_management,
					user_id_arr: JSON.stringify(this.paruseStudent),
					product_ids: JSON.stringify(arr),
					is_first: this.directYear
				}).then(res => {
					if (res.data.status == 'success') {
						this.$message({
							showClose: true,
							message: '开课成功！',
							type: 'success'
						});
						this.dialogdirectVisible = false;
						this.dialogSelectVisible = false;
						this.paruseSelectClass = [];
					} else {
						this.$message({
							showClose: true,
							message: '开课失败' + res.data.errorMsg,
							type: 'danger'
						});
					}
				})
			}
		},
		//搜索课程
		searchClass() {
			this.$post('products/search', {
				token: this.$store.state.authority_management,
				offset: 0,
				length: 15,
				shop_id: 1,
				name: this.classSearchName
			}).then(res => {
				this.selectData = res.data.result.data;
				this.classTotal = res.data.result.total;
			})
		},
		//在已经选择的课程里面选中下单并设置年度
		confirmYearStudy() {
			if (this.paruseClass.length == 0) {
				this.$message({
					showClose: true,
					message: '请至少选择一门课程！',
					type: 'warning'
				});
				return false;
			}
			let paruseClassArr = this.paruseClass;
			let jsonParuse = [];
			let time = this.formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss');
			for (let val of this.paruseClass) {
				jsonParuse.push(val.product_id)
			}
			let obj = {
				token: this.$store.state.authority_management,
				products: JSON.stringify(jsonParuse),
				state: 2,
				pay_type: 1,
				pay_date: time,
				user_id: this.studentId,
				is_first: this.isFirst
			};
			this.$post('orders/selected_create', obj).then(res => {
				this.dialogSelectedVisible = false;
				this.paruseClass = [];
				if (res.data.status == 'success') {
					for (let obj of paruseClassArr) {
						this.$post('selected/delete', {
							token: this.$store.state.authority_management,
							id: obj.id
						}).then(res => {})
					}
					if (this.isFirst && this.isFirst != '') {
						this.$message({
							showClose: true,
							message: '开课成功，且设置课程年度成功！',
							type: 'success'
						});
					} else {
						this.$message({
							showClose: true,
							message: '开课成功，但未设置课程年度！',
							type: 'success'
						});
					}
				} else {
					this.$message({
						showClose: true,
						message: '开课失败，' + res.data.errorMsg,
						type: 'error'
					});
				}
			})
		},

		//转化时间格式 yyyy-MM-dd hh:mm:ss
		formatDate: function(date, fmt) {
			if (/(y+)/.test(fmt)) {
				fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
			}
			let o = {
				'M+': date.getMonth() + 1,
				'd+': date.getDate(),
				'h+': date.getHours(),
				'm+': date.getMinutes(),
				's+': date.getSeconds()
			};
			for (let k in o) {
				if (new RegExp(`(${k})`).test(fmt)) {
					let str = o[k] + '';
					fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : this.padLeftZero(str));
				}
			}
			return fmt;
		},
		//转化时间格式
		padLeftZero: function(str) {
			return ('00' + str).substr(str.length);
		},
		//确定搜索学生
		confirmSearch() {
			this.currentPage = 1
			this.searchType = false;
			// this.studentCurrentPage = 0;
			let data = {
				token: this.$store.state.authority_management,
				offset: this.studentCurrentPage,
				length: this.pageLen,
				shop_id: this.$store.state.store.id

			}
			if (this.searchStudent.company) {
				data.company = this.searchStudent.company
			}
			if (this.searchStudent.name) {
				data.name = this.searchStudent.name
			}
			if (this.searchStudent.phone) {
				data.phone = this.searchStudent.phone
			}
			if (this.searchStudent.idCard) {
				data.idcard = this.searchStudent.idCard
			}
			if (this.searchStudent.gender) {
				data.gender = this.searchStudent.gender
			}
			if (this.searchStudent.created_people) {
				data.created_people = this.searchStudent.created_people
			}
			if (this.searchStudent.birthdate) {
				data.birthdate = this.searchStudent.birthdate
			}
			if (this.searchStudent.email) {
				data.email = this.searchStudent.email
			}
			if (this.searchStudent.balance_egt) {
				data.balance_egt = this.searchStudent.balance_egt
			}
			if (this.searchStudent.balance_elt) {
				data.balance_elt = this.searchStudent.balance_elt
			}
			if (this.searchStudent.province) {
				data.province = this.searchStudent.province
			}
			if (this.searchStudent.note) {
				data.note = this.searchStudent.note
			}

			data.enabled = this.searchStudent.enabled;
			data.created_at_egt = this.searchStudent.created_at_egt;
			data.created_at_elt = this.searchStudent.created_at_elt;

			this.$post('users/search', data).then(res => {
				// console.log('res',res)
				this.studnetData = res.data.result.data;
				this.studentTotal = res.data.result.total;
			})
		},

		//添加学生信息
		addStudent() {},
		//确认添加学生
		// confirmAddStudent() {
		// },
		//删除的时候弹出来
		confirmDeleteSelected(id) {
			// console.log('id：');
			// console.log(id);
			this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.deleteGoods(id)
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		},
		//修改学生信息
		updateStudent() {
			//输入密码框显示
			this.isPassword = true;
			//弹出框显示
			this.dialogFormVisible = true
			//把输入框变为可输入
			this.isInput = {
				name: false,
				idCard: false,
				phone: false,
				company: false,
				email: false,
			}
		},
		//获取学生信息详情
		getStudent() {
			//输入密码框隐藏
			this.isPassword = false;
			//弹出框显示
			this.dialogFormVisible = true
			//把输入框变为不可输入
			this.isInput = {
				name: true,
				idCard: true,
				phone: true,
				company: true,
				email: true,
			}
		},
		//编辑年度按钮
		handleEdit(val) {
			if (val.editing == true) {
				this.temporaryYear = val.is_first;
			} else {
				val.is_first = this.temporaryYear;
				this.temporaryYear = '';
			}
			val.editing = !val.editing;
		},
		//模拟登录
		SimulatedLogin(val) {

			if (this.paruseStudent.length == 0) {
				this.$message({
					type: 'error',
					message: '请选择用户'
				})
				return false
			} else if (this.paruseStudent.length > 1) {
				this.$message({
					type: 'error',
					message: '请选择单个用户'
				})
				return false
			} else {

				let data = {
					user_id: this.paruseStudent[0]
				}
				// console.log(data)
				this.$post('users/getTokenByUserId', data).then(res => {
					// console.log(res);
					this.$store.state.id = res.data.result.token;
					this.$store.state.shopId = res.data.result.shop_id
					this.$post('users/profile', {
						token: this.$store.state.id
					}).then(res => {
						this.$store.state.userId = res.data.result.id;
						this.$store.state.name = res.data.result.name;
						sessionStorage.setItem("tpid", this.$store.state.id);
						sessionStorage.setItem("tpname", this.$store.state.name);
						sessionStorage.setItem('tpuserId', this.$store.state.userId);
						sessionStorage.setItem('tpshopid', this.$store.state.shopId);
					}).then(() => {
						this.$post("shopping_cart/search", {
							token: this.$store.state.authority_management,
							offset: "0",
							length: 9999,
							shop_id: this.$store.state.store.id
						}).then(res => {
							this.$store.state.shopNum = res.data.result.data.length;
							// this.$router.push({
							//     path: '/personalcenter',
							// })
							let address = this.$router.resolve({
								path: '/personalcenter',
							});
							window.open(address.href, "_blank");
						});
					}).then(() => {
						// let address = this.$router.resolve({
						//     path: '/'
						// });
						// window.open(address.href, "_blank");
					});
				})

			}

		},
		//确认更改年度信息
		confirmUpdateYear(val) {
			this.$post('purchased/updateCerYear', {
				token: this.$store.state.authority_management,
				is_first: val.is_first,
				id: val.id
			}).then(res => {
				if (res.data.status == 'success') {
					val.editing = !val.editing;
					this.$message({
						showClose: true,
						message: '修改课程年度成功！',
						type: 'success'
					});
				}
			})
		},
		//删除学员已经购买得课程
		deleteBoughtGoods(id) {

		},
		//删除学生的已选的课程
		// deleteGoods(id) {
		//   console.log('删除的东西');
		//   console.log({ token: this.$store.state.authority_management, id: id });
		//   this.$post('selected/delete', { token: this.$store.state.authority_management, id: id }).then(res => {
		//     if (res.data.status == 'success') {
		//       this.selectedClass(this.studentId);
		//       this.$message({
		//         showClose: true,
		//         message: '删除成功！',
		//         type: 'success'
		//       });
		//     } else {
		//       this.selectedClass(this.studentId);
		//       this.$message({
		//         showClose: true,
		//         message: '删除失败！',
		//         type: 'error'
		//       });
		//     }

		//   })
		// },
		//学员批量选课
		moreChooseClass() {
			if (this.paruseStudent.length == 0) {
				this.$message({
					showClose: true,
					message: '请至少选择一个学员！',
					type: 'warning'
				});
			} else {
				//让批量选课弹出显示
				this.dialogSelectVisible = true;
				this.studentId = 0;
				this.allClassData();
			}

		},
		//单个学员选课
		// allClass(id) {
		//   this.studentId = id;
		//   this.dialogSelectVisible = true
		//   console.log(id);
		//   this.allClassData()
		// },
		//选择课程弹窗关闭时候触发
		// handleClose() {
		//   this.classSearchName = '';
		//   this.dialogSelectVisible = false
		// },
		//显示所有课程数据
		allClassData() {
			this.$post('products/search', {
				offset: this.classCurrentPage,
				length: 15,
				name: this.classSearchName
			}).then(res => {
				this.classTotal = res.data.result.total;
				this.selectData = res.data.result.data;
			})
		},
		//点击选课程多选框
		handleSelectionChange(val) {
			this.paruseSelectClass = val;
		},
		//点击学员多选框
		handleStudentChange(val) {
			if (val.length > 0) {
				this.stuInfo = val[0]
				let arr = [];
				for (let item of val) {
					arr.push(item.id);
				}
				this.paruseStudent = arr;
			} else {
				this.stuInfo = {};
				this.paruseStudent = [];
			}


		},
		//点击已经课程多选框
		handleClassChange(val) {
			this.paruseClass = val;
		},
		//直接开课
		openClass() {
			if (this.paruseSelectClass.length == 0) {
				this.$message({
					showClose: true,
					message: '请至少选择一门课程',
					type: 'warning'
				});
			} else {
				this.dialogdirectVisible = true;
			}
		},
		//确定选择的课程
		confirmClass() {
			if (this.paruseSelectClass.length == 0) {
				this.$message({
					showClose: true,
					message: '请至少选择一门课程',
					type: 'warning'
				});
				return;
			}
			let user_arr = '';
			this.studentId == 0 ? user_arr = JSON.stringify(this.paruseStudent) : user_arr = JSON.stringify([this.studentId]);
			let product_arr = [];
			for (let val of this.paruseSelectClass) {
				product_arr.push(val.id)
			}
			if (this.paruseSelectClass.length != 0) {
				this.$post('selected/create', {
					token: this.$store.state.authority_management,
					user_id_arr: user_arr,
					product_id_arr: JSON.stringify(product_arr)
				}).then(res => {
					if (res.data.status == 'success') {
						//如果成功，则清空在选择课程弹框的勾选的课程数组
						this.paruseSelectClass = [];
						//并且关闭弹框
						this.dialogSelectVisible = false;
						//弹出成功的消息提示
						this.$message({
							showClose: true,
							message: '选课成功！',
							type: 'success'
						});

					}
				})
			} else {
				alert('选择商品为空')
			}
		},
		// //查询该学员已经选的课程
		// selectedClass(id) {
		//   let me = this;
		//   this.studentId = id;
		//   this.selectedData = [];
		//   this.paruseClass = [];
		//   this.dialogSelectedVisible = true
		//   this.$post('selected/search', { token: this.$store.state.authority_management, user_id: id, offset: 0, length: 999 }).then(res => {
		//     this.selectedData=res.data.result.data;
		//   })
		// },
		//点击当前页面获取该有的信息
		getClassPage(currentPage) {
			this.classCurrentPage = (currentPage - 1) * 15;
			// this.allClass(this.studentId);
		},
		//获取所有学生的信息
		getAllStudent() {
			this.fullscreenLoading = true
			this.searchType = true;

			let data = {
				token: this.$store.state.authority_management,
				offset: this.studentCurrentPage,
				length: this.pageLen,
				shop_id: this.$store.state.store.id,
			}
			if (this.searchStudent.company) {
				data.company = this.searchStudent.company
			} else if (this.searchStudent.name) {
				data.name = this.searchStudent.name
			} else if (this.searchStudent.phone) {
				data.phone = this.searchStudent.phone
			} else if (this.searchStudent.idcard) {
				data.idcard = this.searchStudent.idcard
			}

			this.$post('users/search', data).then(res => {
				this.studentTotal = res.data.result.total;
				this.studnetData = res.data.result.data;
				this.fullscreenLoading = false
			})
		},
		//根据分页获取学生信息
		getStudentPage(currentPage) {
			this.currentPage = currentPage;
			if (this.searchType) {
				//根据点击的分页改变数据的偏移量
				this.studentCurrentPage = (Number.parseInt(currentPage) - 1) * this.pageLen;
				//再请求对应的学生信息
				this.getAllStudent();
			} else {
				this.studentCurrentPage = (Number.parseInt(currentPage) - 1) * this.pageLen;
				this.confirmSearch()
			}

		},
		//该学生已经购买的课程
		studentBoughtClass(id) {
			this.classData = [];
			let me = this;
			this.dialogTabelVisible = true;
			this.$post('orders/searchByUserId', {
				token: this.$store.state.authority_management,
				user_id: id,
				offset: 0,
				length: 999
			}).then(res => {
				return res.data.result.data;
			}).then(data => {
				for (let val of data) {
					if (Number.parseFloat(val.state) == 2) {
						(function(id) {
							me.$post('purchased/shop_search', {
								token: me.$store.state.authority_management,
								order_id: id,
								offset: 0,
								length: 999,
							}).then(res => {
								for (let item of res.data.result.data) {
									item.editing = true;
									me.classData.push(item)
									// console.log(me.classData);
								}
							})
						})(val.id)
					}
				}
			})
		},

		// 禁用学生
		disableStudent(user) {
			this.$confirm('确定禁用该名学员?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {

				// 发送请求禁用学员
				this.$post('users/shop_edit', {
					token: this.$store.state.authority_management,
					id: user.id,
					phone: user.phone,
					idcard: user.idcard,
					company: user.company,
					email: user.email,
					enabled: 0
				}).then(res => {
					this.$message({
						type: 'success',
						message: '已禁用该学员'
					})
					this.getAllStudent()
				})

			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消禁用'
				})
			})
		},

		// 禁用多个学员
		disableStudents(state) {
			if (this.paruseStudent.length == 0) {
				this.$message({
					showClose: true,
					message: '请至少选择一个学员！',
					type: 'warning'
				});
			} else {
				let tip = '';
				state === 0 ? tip = '确定禁用选择的学员吗?' : tip = '确定启用选择的学员吗?';
				this.$confirm(tip, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$post('users/batchUserEdit', {
						userIds: JSON.stringify(this.paruseStudent),
						token: this.$store.state.authority_management,
						enabled: state
					}).then(res => {
						this.getAllStudent()
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消禁用'
					})
				})
			}

		},



		//上传的一堆回调方法
		beforeUploadTwo(file) {
			let str = file.name;
			if (str.substr(str.length - 3, 3).toLocaleLowerCase() != "xls") {
				alert('excel文件必须是xls格式')
				return false;
			}
		},
		handleExceedTwo(files, fileList) {
			this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
		},
		beforeRemoveTwo(file) {
			return this.$confirm(`确定移除 ${file.name}？`);
		},
		isOkTwo(response) {
			alert(response);
		},

		// 导出excel
		exportExcel() {
			this.excelDialog = true;

			//前端导出
			// let wb = XLSX.utils.table_to_book(document.getElementById('out-table'), {
			//     raw: true
			// })

			// let wbout = XLSX.write(wb, {
			//     bookType: 'xlsx',
			//     bookSST: true,
			//     type: 'array'
			// })
			// try {
			//     FileSaver.saveAs(new Blob([wbout], {
			//         type: 'application/octet-stream'
			//     }), 'test.xlsx')
			// } catch (e) {
			//     if (typeof console !== 'undefined') console.log(e, wbout)
			// }
			// return wbout
		},

		//确认导出
		confirmexport() {
			this.exportLoading = true;
			this.excelDialog = false;
			if (this.exceldata.offset && this.exceldata.length) {
				this.$post('users/memberExport', {
					token: this.$store.state.authority_management,
					offset: this.exceldata.offset,
					length: this.exceldata.length
				}).then(res => {
					this.exportLoading = false;
					window.open(res.data.result)
				})
			} else {
				this.$message({
					type: 'error',
					message: '请填写起始位置与长度'
				})
			}
		},

		// 在输入框输入数据时触发
		inputNumber(e) {
			e >= 20000 ? this.exceldata.length = 20000 : this.exceldata.length = e;
		}

	},
	created() {
		this.getAllStudent();
	}

}
